"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
  query tags {
    tags {
      _id
      name
      createdAt
      updatedAt
    }
  }
`;
exports.default = query;
//# sourceMappingURL=tags.query.js.map